"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitalBridgeTransport = exports.JWTTransport = exports.Transport = void 0;
const tslib_1 = require("tslib");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
class Transport {
    constructor() {
        this._headers = {};
    }
    addHeader(key, value) {
        this._headers[key] = value;
    }
    executeRequest(req) {
        return axios_1.default
            .request({
            method: req.method,
            url: req.endpoint,
            data: req.data !== undefined && req.data.data !== undefined
                ? req.data.data
                : {},
            headers: this._headers,
        })
            .then((req) => req.data);
    }
}
exports.Transport = Transport;
class JWTTransport extends Transport {
    constructor(JWT) {
        super();
        this.JWT = JWT;
        this._listeners = [];
        this.updateAuthHeader();
    }
    setJWT(token) {
        this.JWT = token;
        this._listeners.forEach((listener) => listener(this.getJWT()));
        this.updateAuthHeader();
    }
    getJWT() {
        return this.JWT;
    }
    onJWTChange(listener) {
        this._listeners.push(listener);
    }
    updateAuthHeader() {
        this.addHeader('Authorization', `Bearer ${this.JWT}`);
    }
}
exports.JWTTransport = JWTTransport;
class DigitalBridgeTransport {
    constructor() {
        this._transport = new Transport();
    }
    addHeader(key, value) {
        this._transport.addHeader(key, value);
    }
    addSpace(header) {
        this._transport.addHeader('X-DigitalBridge-Space', header);
    }
    addScope(headers) {
        if (headers.length === 0) {
            throw new Error('Unable to add scope headers - zero scopes provided');
        }
        this._transport.addHeader('X-DigitalBridge-Scopes', headers.length > 1
            ? headers.reduce((a, b) => `${a} ${b}`, '')
            : headers[0]);
    }
    addSubject(header) {
        this._transport.addHeader('X-DigitalBridge-Subject', header);
    }
    executeRequest(req) {
        return this._transport.executeRequest(req);
    }
}
exports.DigitalBridgeTransport = DigitalBridgeTransport;
